var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngularjs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82501 16.675L39.625 5V75L11.925 59.7L6.82501 16.675Z",
    fill: "#DE3641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.625 5L73.175 16.475L67.7 59.5L39.625 75V5Z",
    fill: "#B13138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.625 12.85L60.95 58.425H53.675L49.125 48.025H39.625V41.825H46.55L39.625 27.5L33.8 41.825H39.625V48.025H30.95L26.875 58.425H19.025L39.625 12.85Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.475 70.85L43.675 39.35H74.55L71.725 70.85L59.1 74.35L46.475 70.85Z",
    fill: "#1572B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 71.675L69.325 68.825L71.725 41.925H59.1V71.675Z",
    fill: "#33A9DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 53.325H64.225L64.575 49.375H59.1V45.5H59.125H68.8L68.7 46.55L67.75 57.2H59.1V53.325Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.125 63.375L54.825 62.2L54.55 59.125H52.45H50.65L51.2 65.2L59.1 67.4L59.125 67.375V63.375Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9 57.025L63.425 62.2L59.125 63.375V67.4L67.05 65.2L67.1 64.55L67.775 57.025H63.9Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.125 45.5V47.9V49.375H49.8L49.725 48.5L49.525 46.55L49.45 45.5H59.125Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1 53.325V55.725V57.2H54.875H54.85L54.775 56.325L54.6 54.375L54.525 53.325H59.1Z",
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularjs);
export default __webpack_public_path__ + "static/media/angularjs.cbf2d613069ddb3d54b359fb0e0fb784.svg";
export { ForwardRef as ReactComponent };